export enum DbMigrationStatusKind {
    PENDING = 0,
    EXECUTED = 1,
    ERROR = 2
}
